@let canReadTemplate = userContextService.canReadCommunicationTemplate();

<div class="template-list-page">
  <div class="template-list-page">
    <topo-data-table-server
      #table
      [isActive]="true"
      [tableHidden]="isTableLoading"
      [datasource]="datasource"
      [columns]="columDefs"
      [showHeader]="false"
      [headerLabel]="'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATES' | translate"
      [newLabel]="'MANAGEMENT.COMMUNICATION-CENTER.NEW-TEMPLATE' | translate"
      [headerIcon]="'assets/images/template.svg'"
      [showNewButton]="canAddTemplate && userContext?.hasPermission(Permissions.CommunicationTemplateCreate)"
      [showHeader]="true"
      [showSearch]="canReadTemplate"
      [showMenu]="false"
      [showRowGroups]="false"
      [showSystemFields]="true"
      [enableInfiniteScroll]="false"
      [enableServerSort]="true"
      [enableServerFilter]="true"
      (paginate)="onPaginate($event)"
      (newClick)="newTemplate()"
      (takeChanged)="onTakeChanged($event)"
      [skip]="skip"
      [take]="take"
      [getRowId]="getRowId"
      (storeUpdatedCalled)="onGridDataLoaded()"
      [totalCount]="totalCount">
      @if (userContext?.hasPermission(Permissions.CommunicationTemplateCreate)) {
        <div class="mr-3" ngProjectAs="aux-buttons">
          <button
            class="button is-secondary is-medium"
            (click)="openTemplateGroupDialog()">
            {{ 'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUPS' | translate }}
          </button>
        </div>
      }
    </topo-data-table-server>
  </div>

<topo-confirm-delete
  [isActive]="!!notificationTemplateToDelete"
  (confirmResponse)="confirmDeleteNotificationTemplate($event)"></topo-confirm-delete>

<topo-confirm
  [isActive]="showCannnotDelete"
  (respond)="onConfirmCannotDelete($event)"
  title="{{ 'COMMUNICATIONS.CANNOT-DELETE-ITEM' | translate }}"
  hideNo="true"
  [message]="cannnotDeleteMessage"
  yesText="{{ 'COMMUNICATIONS.CONFIRM-OK' | translate }}"
  icon="icon-delete_trash"></topo-confirm>

  @if (showTemplateEdit$ | async) {
    <topo-comms-template-edit />
  }
</div>
